// extracted by mini-css-extract-plugin
export default {"arrowDown":"ArrowDown_arrowDown__GYoAt"};